(() => {
  const initialize = root => {
    if (root.dataset.shapeInitialized) return;
    root.dataset.shapeInitialized = 'true';
    const data = root.querySelector('[data-has-variants]');
    if (!data) return;
    let variants;
    try { variants = JSON.parse(data.textContent); } catch { return; }
    const keys = {'שוקולד':'chocolate','לאטה':'latte','ניוד':'nude','חול':'sand','שחור':'black'};
    let mapping = {};
    try { mapping = JSON.parse(document.getElementById('cuppy-lift-media-config')?.textContent || '{}').__shape || {}; } catch {}
    const update = () => root.querySelectorAll('.quantity-break__selector-item').forEach(row => {
      const selects = [...row.querySelectorAll('.quantity-break__variant-select')];
      const variant = variants.find(candidate => candidate.options.every((value, index) => value === selects[index]?.value));
      const image = row.querySelector('.cuppy-bundle-photo img');
      if (!image || !variant) return;
      image.dataset.originalSrc ||= image.src;
      const color = selects[1]?.value;
      const sibling = variants.find(candidate => candidate.option2 === color && (candidate.featured_image?.src || candidate.featured_media?.preview_image?.src));
      const photo = mapping[keys[color]] || variant.featured_image?.src || variant.featured_media?.preview_image?.src || sibling?.featured_image?.src || sibling?.featured_media?.preview_image?.src;
      image.removeAttribute('srcset');
      image.src = photo || image.dataset.originalSrc;
      image.alt = selects.map(select => select.value).join(' — ');
    });
    root.addEventListener('change', () => requestAnimationFrame(update));
    update();
  };
  const scan = () => document.querySelectorAll('[data-cuppy-shape-bundle]').forEach(initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  document.addEventListener('shopify:section:load', scan);
})();
